export const DRIVER_SCOPE = "Driver";
export const SQUAD_SCOPE = "Squad";

export type RosterScope = typeof DRIVER_SCOPE | typeof SQUAD_SCOPE;

export const isRosterScope = (
  value: string | undefined
): value is RosterScope => {
  return !!value && (value === DRIVER_SCOPE || value === SQUAD_SCOPE);
};
